import React from 'react'
import { makeStyles, useTheme } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import ContentWrapper from './contentWrapper'
import MainWrapper from './mainWrapper'
import { isMeinBuero } from '@/utils/build-env'
import { prevStep } from '@/redux/ducks/wizard/config'
import lang from '@/lang'

import MobileLogo from '@assets/images/onboarding/logo_mobile.svg'
import BackArrowIcon from '@assets/images/icons/arr_left.svg'
import RocketIcon from '@assets/images/icons/rocket.svg'
import OMOLogo from '@assets/images/logo/svg/logo.svg'
import MBOLogo from '@assets/images/logo/svg/logoV3.svg'
import KanzleiLogo from '@assets/images/logo/kanzlei-logo.svg'

const isMeinbuero = isMeinBuero()

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: 570,
    marginTop: 20,
    position: 'relative',
    '@media (min-width: 800px)': {
      display: 'none',
    },

    [theme.devices.mobile]: {
      display: isMeinbuero ? 'none' : 'flex',
    },
  },
  logoWrapper: {
    gap: 50,
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
    width: '100%',
    padding: 30,
    justifyContent: 'center',

    '@media (max-width: 800px)': {
      display: isMeinbuero ? 'flex' : 'none',
      paddingBottom: isMeinbuero ? 0 : 30,
    },
  },
  logo: {
    height: 30,

    [theme.devices.mobile]: {
      height: '35px !important',
    },
  },
  backButton: {
    width: 30,
    height: 30,
    top: '25px',
    left: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 'auto',
    border: '0 none',
    background: 'transparent',
    position: 'absolute',

    [theme.devices.mobile]: {
      top: 0,
      left: '10px',
      justifyContent: 'space-between',
    },
  },
  backButtonText: {
    color: theme.black,
    paddingLeft: 10,
  },
}))

const PageWrapper = ({
  finishView,
  children,
  title,
  text,
  description,
  skippable,
  width,
  onBackButtonClick = null,
  disabled = false,
  onNextButtonClick,
  onSkipButtonClick,
  isMboOnboarding,
  stickyBottomForMobile = false,
}) => {
  const dispatch = useDispatch()
  const theme = useTheme()

  const { tenant: { info: { subscriptions } }, wizard: { config: { step } } } = useSelector(state => state)
  const isTaxConsultant = subscriptions?.some(s => s.isTaxConsultant)
  const classes = useStyles()
  const logo = isMeinbuero ? MBOLogo : OMOLogo

  const prev = () => {
    dispatch(prevStep())
    onBackButtonClick && onBackButtonClick()
  }

  const showLogo = () => {
    if (isTaxConsultant) {
      return (
        <SVGIcon
          height={isMeinbuero ? '48px' : '36px'}
          width={isMeinbuero ? '189px' : '160px'}
          svg={KanzleiLogo}
        />
      )
    }

    return <SVGIcon height={36} width={'auto'} svg={logo} />
  }

  return (
    <ContentWrapper>
      <div className={classes.logoWrapper}>
        {step > 0 && onBackButtonClick && (
          <button type="button" className={classes.backButton} onClick={prev}>
            <SVGIcon svg={BackArrowIcon} height='16px' width='14px' fill={theme.black} />
            <span className={classes.backButtonText}>{lang.onboardingV2.general.back}</span>
          </button>
        )}
        {showLogo()}
        {(finishView && !isMeinbuero) && <SVGIcon svg={RocketIcon} height='146px' width='146px' fill={theme.black} />}
      </div>
      <header className={classes.header}>
        {step > 0 && onBackButtonClick && (
          <button type="button" className={classes.backButton} onClick={prev}>
            <SVGIcon svg={BackArrowIcon} height='16px' width='14px' fill={theme.black} />
            <span className={classes.backButtonText}>{lang.onboardingV2.general.back}</span>
          </button>
        )}
        <SVGIcon className={classes.logo} height="30px" svg={MobileLogo} />
      </header>
      <MainWrapper
        finishView={finishView}
        width={width}
        skippable={skippable}
        title={title}
        text={text}
        description={description}
        onBackButtonClick={onBackButtonClick}
        disabled={disabled}
        onNextButtonClick={onNextButtonClick}
        onSkipButtonClick={onSkipButtonClick}
        isMboOnboarding={isMboOnboarding}
        stickyBottomForMobile={stickyBottomForMobile}
      >
        {children}
      </MainWrapper>
    </ContentWrapper>
  )
}

MainWrapper.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onNextButtonClick: PropTypes.func,
  onSkipButtonClick: PropTypes.func,
  onBackButtonClick: PropTypes.func,
  skippable: PropTypes.bool,
  width: PropTypes.number,
  finishView: PropTypes.bool,
  isMboOnboarding: PropTypes.bool,
  stickyBottomForMobile: PropTypes.bool,
}

MainWrapper.defaultProps = {
  disabled: false,
  skippable: false,
  finishView: false,
  stickyBottomForMobile: false,
}

export default PageWrapper
